import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import urlTemplate from 'url-template';
import type { UmmDetailsResponse } from 'src/apis/iip-service/types';
import type { UmmsRequest } from 'src/apis/iip-service/use-umms';
import { useAxios } from 'src/hooks/use-axios';

type HookProps = {
  ummsRequest: UmmsRequest;
  onError?: (error: unknown) => unknown;
};

type RequestOptions = {
  url: string;
};

export const useUmm = ({ ummsRequest, onError }: HookProps) => {
  const { ummId } = useParams<{
    ummId: string;
  }>();
  const request = useAxios(
    (axios, baseConfig, { url }: RequestOptions) => {
      return axios.request<UmmDetailsResponse>({
        ...baseConfig,
        url,
      });
    },
    { neededOnPageLoad: true, onError }
  );

  useEffect(() => {
    if (!ummsRequest.response) return;

    const url = urlTemplate
      .parse(ummsRequest.response.data._links.instance.href)
      .expand({ ummId });

    request.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [ummsRequest.response, ummId]);

  return request;
};

export type UmmDetailsRequest = ReturnType<typeof useUmm>;
